module.exports = __webpack_public_path__ + "../resources/img/@temp_chart_3.61c17e02.jpg";